import { render, staticRenderFns } from "./MultipleForApprovalDisposal.vue?vue&type=template&id=b69d7d8c"
import script from "./MultipleForApprovalDisposal.vue?vue&type=script&lang=js"
export * from "./MultipleForApprovalDisposal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports